import styled from 'styled-components';

export const AccountSettingsContainer = styled.div`
    padding: 15px;
`
export const AccountSettingsNav = styled.div`
    padding: 20px;
    margin-block: 15px;
    background-color: ${({theme}) => theme.colors.primary};
    border: 1px solid ${({theme}) => theme.colors.link.text};
    border-radius: 10px;
    cursor: pointer;
`